import { Pipe, PipeTransform } from '@angular/core';
import { TitleBlockSection } from '@app/routes/drawing-helper/model/titleblock/titleblocksection.model';

@Pipe({
    name: 'titleBlockFilterPipe'
})
export class TitleBlockFilterPipe implements PipeTransform {
    transform(items: TitleBlockSection[]): any {
        if (!items) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter(item => item.isVisible !== false);
    }
}